<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_842')}}</div>
    <div slot="body">
      <ul class="pay-type">
        <li class="pay-type-item mb-2 pay-type-current">
          <div class="radio-box">
            <div class="radio">
              <a-radio checked />
            </div>
            <div class="radio-text">
              <icon type="alipay" class="ali-icon mr-2" />{{$t('scope.wechat_pay')}}</div>
          </div>
        </li>
        <li class="pay-type-item mb-2 pay-type-current">
          <div class="radio-box">
            <div class="radio">
              <a-radio checked />
            </div>
            <div class="radio-text">
              <icon type="alipay" class="ali-icon mr-2" />{{$t('scope.alipay')}}</div>
          </div>
        </li>
      </ul>
      <div class="tip-wrapper">
        <div class="tip">
          <span>{{$t('scope.text_843')}}</span>
          <div class="alipay">
            <ol>
              <li>{{$t('scope.text_844')}}</li>
              <li>{{$t('scope.text_845')}}</li>
              <li>{{$t('scope.text_846')}}</li>
            </ol>
          </div>
        </div>
      </div>
      <a-checkbox v-model="isAgreen" class="mt-4">{{$t('scope.recharge_agreement')}}</a-checkbox>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading" :disabled="!isAgreen">{{$t('scope.text_465')}}</a-button>
      <a-button @click="cancelDialog">{{$t('scope.text_457')}}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapState } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'ChoosePaymentMethodDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      isAgreen: false,
    }
  },
  computed: {
    ...mapState('app', {
      customer: state => state.customer,
    }),
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        const { data } = await this.doPay()
        this.loading = false
        window.open(data.location)
        this.cancelDialog()
        if (this.params.cancel) {
          this.params.cancel()
        }
        this.createDialog('DepositResultDialog', {
          id: data.id,
          onManager: this.params.onManager,
          refresh: this.params.refresh,
          cancel: () => {
            this.cancelDialog()
          },
        })
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
  .pay-type {
    list-style: none;
    padding: 0;
    .pay-type-item {
      width: 260px;
      cursor: pointer;
      border-width: 1px;
      border-style: solid;
      border-color: rgb(215, 216, 217);
      border-image: initial;
      .radio-box {
        padding: 12px 16px;
        .radio {
          display: inline-block;
        }
        .radio-text {
          display: inline-block;
          vertical-align: top;
          font-size: 18px;
          .ali-icon {
            font-size: 22px;
          }
        }
      }
    }
    .pay-type-current {
      border-width: 2px;
      border-style: solid;
      border-color: rgb(255, 166, 0);
      border-image: initial;
    }
  }
  .tip-wrapper {
    font-size: 14px;
    width: 100%;
    .tip {
      color: rgb(85, 85, 85);
      background-color: rgb(249, 249, 249);
      line-height: 24px;
      margin-bottom: 6px;
      border-width: 1px;
      border-style: solid;
      border-color: rgb(221, 221, 221);
      border-image: initial;
      padding: 20px 12px;
      ol {
        list-style: none;
        counter-reset: li 0;
        padding: 0px;
        margin: 0px 0px 0px 16px;
        li:nth-child(2) {
          color: rgb(238, 103, 35);
        }
      }
    }
  }
</style>
